import {apiWithToken} from "../../../systems/api";
import {API_URL} from "../../../systems/globalContant";

export default {
    getOrderById: id => apiWithToken.get(API_URL.DEFAULT + `/orders/${id}/finali`, {}, {loading: false})
};;